import React from 'react';
import { Grid, Typography } from '@mui/material';

// Define the props interface
interface ClientInformationFormProps {
  companyName?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  onHandleChange: (e: any, fieldName: string) => void;
  handlePhone: (e: any) => void;
  validator: any;
  formatPhoneNumberInput: (value?: string) => string;
  StyledTextField: any;
  classes: any;
}

const ClientInformationForm: React.FC<ClientInformationFormProps> = ({
  companyName,
  firstName,
  lastName,
  email,
  phoneNumber,
  onHandleChange,
  handlePhone,
  validator,
  formatPhoneNumberInput,
  StyledTextField,
  classes,
}) => {
  return (
    <>
      <Typography
        gutterBottom={true}
        sx={{
          mt: 4,
          mb: 2,
          fontSize: { sm: "20px" },
          fontWeight: 600,
        }}
      >
        Client Information
      </Typography>
      <Grid container={true} spacing={2} direction="row">
        <Grid item={true} xs={12} sm={12}>
          <StyledTextField
            id="companyName"
            label="Company (Optional)"
            className={`${classes.marginBottom5} ${classes.fullWidth}`}
            value={companyName}
            variant="outlined"
            onChange={(e: any) => onHandleChange(e, "companyName")}
          />
        </Grid>
        <Grid item={true} xs={12} sm={6}>
          <StyledTextField
            autoComplete="given-name"
            name="firstName"
            className={classes.marginBottom5}
            required={true}
            id="firstName"
            label="First name"
            value={firstName}
            onChange={(e: any) => onHandleChange(e, "firstName")}
            onBlur={() =>
              validator.message(
                "firsrt name",
                typeof firstName === "string"
                  ? firstName.trim()
                  : firstName,
                "required|noSpecialChar"
              )
            }
            fullWidth={true}
            variant="outlined"
          />
          {validator.message(
            "first name",
            firstName,
            "required|noSpecialChar"
          )}
        </Grid>
        <Grid item={true} xs={12} sm={6}>
          <StyledTextField
            name="lastName"
            autoComplete="family-name"
            className={classes.marginBottom5}
            required={true}
            id="lastName"
            value={lastName}
            onChange={(e: any) => onHandleChange(e, "lastName")}
            onBlur={() =>
              validator.message(
                "last name",
                typeof lastName === "string"
                  ? lastName.trim()
                  : lastName,
                "required|noSpecialChar"
              )
            }
            label="Last name"
            fullWidth={true}
            variant="outlined"
          />
          {validator.message(
            "last name",
            lastName,
            "required|noSpecialChar"
          )}
        </Grid>
        <Grid item={true} xs={12} sm={6}>
          <StyledTextField
            name="email"
            autoComplete="email"
            className={classes.marginBottom5}
            required={true}
            id="email"
            value={email}
            onChange={(e: any) => onHandleChange(e, "email")}
            onBlur={() => validator.showMessageFor("email")}
            label="Email"
            fullWidth={true}
            variant="outlined"
          />
          {validator.message("email", email, "required|email")}
        </Grid>
        <Grid item={true} xs={12} sm={6}>
          <StyledTextField
            name="phoneNumber"
            autoComplete="tel"
            className={classes.marginBottom5}
            required={true}
            id="phoneNumber"
            value={formatPhoneNumberInput(phoneNumber)}
            placeholder="(xxx) xxx-xxxx"
            onChange={handlePhone}
            onBlur={() =>
              validator.message(
                "phone number",
                typeof phoneNumber === "string"
                  ? phoneNumber.trim()
                  : phoneNumber,
                "required|phone"
              )
            }
            label="Phone Number"
            fullWidth={true}
            variant="outlined"
          />
          {validator.message(
            "phone number",
            phoneNumber,
            "required|phone"
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default ClientInformationForm;